import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/GlobalStyles';

const TermsContainer = styled.div`
  max-width: 1000px;
  margin: 40px auto;
  padding: 30px;
  background: ${theme.glassMorphism.background};
  backdrop-filter: blur(${theme.glassMorphism.blur});
  -webkit-backdrop-filter: blur(${theme.glassMorphism.blur});
  border-radius: 12px;
  border: ${theme.glassMorphism.border};
  box-shadow: ${theme.glassMorphism.boxShadow};
`;

const Section = styled.section`
  margin-bottom: 30px;
  
  h2 {
    color: ${theme.colors.secondary};
    margin-bottom: 15px;
    position: relative;
    padding-bottom: 10px;
    
    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 40px;
      height: 3px;
      background: linear-gradient(to right, ${theme.colors.primary}, ${theme.colors.accent});
      border-radius: 2px;
    }
  }
  
  p, li {
    margin-bottom: 15px;
    line-height: 1.7;
    color: ${theme.colors.text};
  }
  
  ul, ol {
    margin-left: 20px;
    margin-bottom: 20px;
  }
`;

const Title = styled.h1`
  font-size: 2.2rem;
  margin-bottom: 30px;
  text-align: center;
  background: linear-gradient(to right, ${theme.colors.primary}, ${theme.colors.accent});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const LastUpdated = styled.p`
  text-align: right;
  font-size: 0.9rem;
  color: ${theme.colors.textSecondary};
  margin-top: 40px;
  font-style: italic;
`;

const Terms = () => {
  return (
    <TermsContainer>
      <Title>Términos y Condiciones</Title>
      
      <Section>
        <h2>1. Introducción</h2>
        <p>Estos Términos y Condiciones rigen el uso del bot "TuSecreto" (en adelante "el Bot") en la plataforma Discord. Al utilizar el Bot, aceptas estos términos en su totalidad. Si no estás de acuerdo con estos términos, por favor, absténte de utilizar el Bot.</p>
      </Section>
      
      <Section>
        <h2>2. Descripción del Servicio</h2>
        <p>TuSecreto es un bot para Discord que permite a los usuarios enviar mensajes anónimos en canales específicos. El Bot está diseñado para permitir que los miembros de un servidor compartan pensamientos, confesiones y secretos sin revelar su identidad.</p>
      </Section>
      
      <Section>
        <h2>3. Responsabilidad del Contenido</h2>
        <p>Los operadores de TuSecreto no son responsables del contenido enviado a través del Bot. La responsabilidad legal del contenido recae exclusivamente en:</p>
        <ul>
          <li>Los usuarios que envían los mensajes anónimos</li>
          <li>Los administradores de los servidores que han configurado y habilitado el Bot</li>
        </ul>
        <p><strong>Descargo de responsabilidad importante:</strong> TuSecreto actúa únicamente como un intermediario tecnológico para la transmisión de mensajes anónimos. No moderamos, aprobamos ni respaldamos ningún contenido enviado a través del Bot.</p>
      </Section>
      
      <Section>
        <h2>4. Uso de Canales NSFW</h2>
        <p>Para contenido para adultos o sensible:</p>
        <ul>
          <li>Los administradores de los servidores son los únicos responsables de configurar correctamente los canales como NSFW cuando sea necesario, de acuerdo con las políticas de Discord.</li>
          <li>El Bot no verifica ni garantiza que el contenido para adultos se comparta exclusivamente en canales NSFW.</li>
          <li>Los administradores del servidor deben asegurarse de que todos los usuarios tienen la edad legal para acceder a contenido para adultos según las leyes aplicables en su jurisdicción.</li>
        </ul>
        <p>Discord requiere que el contenido NSFW se comparta exclusivamente en canales marcados como tal. El incumplimiento de esta política puede resultar en la suspensión del servidor por parte de Discord.</p>
      </Section>
      
      <Section>
        <h2>5. Restricciones de Contenido</h2>
        <p>Está estrictamente prohibido utilizar el Bot para compartir:</p>
        <ul>
          <li>Contenido ilegal según las leyes aplicables</li>
          <li>Material que infrinja los Términos de Servicio de Discord</li>
          <li>Contenido que promueva el odio o la discriminación</li>
          <li>Material que constituya acoso o intimidación</li>
          <li>Contenido que viole los derechos de propiedad intelectual de terceros</li>
          <li>Información personal identificable de otros sin su consentimiento</li>
        </ul>
      </Section>
      
      <Section>
        <h2>6. Vacío Legal en Discord</h2>
        <p>Es importante destacar que Discord, como plataforma, tiene su propio conjunto de Términos de Servicio y Directrices Comunitarias. El uso de TuSecreto no exime a los usuarios o administradores de servidor de cumplir con estos términos.</p>
        <p>La anonimidad proporcionada por el Bot no constituye una protección legal contra las consecuencias de compartir contenido prohibido. Discord mantiene registros que podrían ser requeridos por las autoridades, independientemente del uso de herramientas de anonimato.</p>
        <p>Además, bajo las leyes de muchas jurisdicciones, los administradores de servidores pueden ser legalmente responsables del contenido compartido en sus servidores, incluso si dicho contenido fue compartido de forma anónima.</p>
      </Section>
      
      <Section>
        <h2>7. Privacidad y Anonimidad</h2>
        <p>Aunque el Bot está diseñado para permitir mensajes anónimos, debes entender que:</p>
        <ul>
          <li>La anonimidad no es absoluta y puede estar sujeta a requisitos legales</li>
          <li>En caso de investigación legal, podríamos estar obligados a proporcionar cualquier información técnica disponible</li>
          <li>No almacenamos quién envió cada mensaje más allá de lo técnicamente necesario para el funcionamiento del servicio</li>
        </ul>
      </Section>
      
      <Section>
        <h2>8. Modificaciones a los Términos</h2>
        <p>Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación. El uso continuado del Bot después de cualquier modificación constituye la aceptación de los nuevos términos.</p>
      </Section>
      
      <Section>
        <h2>9. Contacto</h2>
        <p>Si tienes preguntas sobre estos términos, puedes contactarnos a través de nuestro servidor de Discord oficial.</p>
      </Section>

      <LastUpdated>Última actualización: {new Date().toLocaleDateString()}</LastUpdated>
    </TermsContainer>
  );
};

export default Terms; 